import styled from "styled-components/macro";
import { Checkbox } from "antd";
import { COLORS, SIZES, WEIGHT } from "../../../../../layout/theme";

export const InnerForm = styled.div`
	display: flex;
	gap: 50px;
`;
export const ProductData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	flex: 1 1 65%;

	.ant-form-item-explain-error {
		white-space: nowrap;
	}
`;
export const PublishSettings = styled.div`
	flex: 1 1 35%;
	background-color: white;
	border-radius: 10px;
`;
export const DistributorImage = styled.img`
	width: 40px;
	height: 40px;
	object-fit: contain;
`;
export const Container = styled.div`
	position: sticky;
	top: 0;
	padding: 2rem;
`;

export const LinkBrand = styled.span`
	color: ${COLORS.Grey};
	font-weight: ${WEIGHT.ExtraBold};
	font-size: ${SIZES.level7};
	line-height: 1.5;
	cursor: pointer;
`;

export const AntdCheckbox = styled(Checkbox)``;

export const CardContainer = styled.div`
	background-color: ${COLORS.White};
	border-radius: 10px;
	padding: 1rem;
`;
